<template>
  <div class="innerSticker divMarginBottom feedback-warning-highlight-surface">
    <slot name="no-transactions">No transactions</slot>
  </div>
</template>

<script>
// Static "join a unit" prompt for viewers without an organisation. The
// legacy direct-Firestore organisation/Wallet reads that selected other
// states were retired with browser Firestore access.
export default {
  name: "OrganisationCoinStatus",
};
</script>
